import * as React from 'react';

import './News.css';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { newsSelector } from '../../store/ducks/news/selectors/newsSelector';
import { newsOneSelector } from '../../store/ducks/newsOne/selectors/newsOneSelector';

import { getNews, getNewsIdle } from '../../store/ducks/news/actions';
import { getNewsOne, getNewsOneIdle } from '../../store/ducks/newsOne/actions';

import { StateStatus } from '../../types/models';
import { Link } from 'react-router-dom';
import { NewsSelectorOmitType } from '../../store/ducks/newsOne/types';
import { NewsSelectorType } from '../../store/ducks/newsOne/types';

import { NewsState } from '../../store/ducks/news/types';
import { Loading } from '../../components/UI/Loading/Loading';
import _ from 'lodash';
import { useScroll } from '../../hooks/useScroll';

export default function News() {
    const dispatch = useDispatch();
    const statusOneNews = useSelector(
        (state: { newsOne: { status: StateStatus } }) => state.newsOne.status
    );
    const { newsOne }: { newsOne: NewsSelectorType } = useSelector(
        newsOneSelector
    );
    const { status, page } = useSelector(
        (state: { news: NewsState }) => state.news
    );

    const { news }: { news: NewsSelectorOmitType[] } = useSelector(
        newsSelector
    );
    const { slug }: { slug: string } = useParams();

    useScroll(news, page, 5, 80);

    useEffect(() => {
        if (status === 'SUCCESS') {
            dispatch(getNewsIdle());
            dispatch(getNewsOneIdle());
        }
    }, [status]);

    useEffect(() => {
        const header = document.querySelector(".header");
        header.classList.remove('_active');
        if (status === 'IDLE') {
            if (slug) {
                dispatch(getNewsOne(slug));
            }
            dispatch(getNews({ limit: 5, page: 1 }));
        }
    }, []);

    

    if (statusOneNews === 'LOADING') return <Loading />;

    return (
        <>
            <main className="page">
                <div className="news page__news-post">
                    {newsOne && (
                        <section
                            data-slug={newsOne.slug}
                            data-id={newsOne.id}
                            className="news-post"
                            key={newsOne.id}
                        >
                            <div className="news-post__header">
                                <div className="news-post__container">
                                    <div className="news-post__header-content">
                                        <div className="news-post__info">
                                            <span className="news-post__tag">
                                                новости
                                            </span>
                                            <div className="news-post__data">
                                                {newsOne.date}
                                            </div>
                                        </div>
                                        <div
                                            // to={newsOne.slug}
                                            className="news-post__title"
                                            dangerouslySetInnerHTML={{
                                                __html: newsOne.title,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div className="news-post__body">
                                <div className="news-post__container">
                                    <div className="news-post__body-content">
                                        <div
                                            className="article__body-content article__body-content--full"
                                            dangerouslySetInnerHTML={{
                                                __html: newsOne.content,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}
                    {news
                        .filter(n => !newsOne || n.id !== newsOne.id)
                        .map(n => {
                            return (
                                <section
                                    data-slug={n.dataSlug}
                                    data-id={n.id}
                                    className="news-post"
                                    key={n.id}
                                >
                                    <div className="news-post__header">
                                        <div className="news-post__container">
                                            <div className="news-post__header-content">
                                                <div className="news-post__info">
                                                    <span className="news-post__tag">
                                                        новости
                                                    </span>
                                                    <div className="news-post__data">
                                                        {n.date}
                                                    </div>
                                                </div>
                                                <div
                                                    // to={n.slug}
                                                    className="news-post__title"
                                                    dangerouslySetInnerHTML={{
                                                        __html: n.title,
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="news-post__body">
                                        <div className="news-post__container">
                                            <div className="news-post__body-content">
                                                <div
                                                    className="article__body-content article__body-content--full"
                                                    dangerouslySetInnerHTML={{
                                                        __html: n.content,
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        })}
                </div>
            </main>
        </>
    );
}
